import { useState } from "react";
import useUpdateDoc from "../../../../hooks/useUpdateDoc";

function EditEmployee({ currentRequest }) {
  const [dataC, setDataC] = useState({
    name: currentRequest?.name,
    lastName: currentRequest?.lastName,
    email: currentRequest?.email,
    cellphone: currentRequest?.cellphone,
  });
  const [fetching, setFetching] = useState(false);
  const [done, setDone] = useState(false);

  const { handleUpdate } = useUpdateDoc();

  const handleUpdateEmployee = async () => {
    try {
      setFetching(true);

      handleUpdate("requests", currentRequest.uuid, {
        cellphone: dataC.cellphone,
        email: dataC.email,
        name: dataC.name,
        lastName: dataC.lastName,
      });

      setFetching(false);

      setDone(true);
    } catch (error) {
      console.log(error);
      setFetching(false);
      setDone(false);
    } finally {
      setFetching(false);
    }
  };

  return (
    <div>
      <p className="text-xl font-semibold">
        Editar a {currentRequest.name} {currentRequest.lastName}
      </p>
      <hr className="mt-2" />

      <div className="mt-3">
        <div className="flex items-center w-full mx-auto justify-center mt-5">
          <div className="flex gap-3">
            <input
              type="text"
              id="simple-search"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Correo"
              required
              value={dataC.email}
              onChange={(e) => setDataC({ ...dataC, email: e.target.value })}
            />

            <input
              type="text"
              id="simple-search"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Nombres"
              required
              value={dataC.name}
              onChange={(e) => setDataC({ ...dataC, name: e.target.value })}
            />

            <input
              type="text"
              id="simple-search"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Apellidos"
              required
              value={dataC.lastName}
              onChange={(e) => setDataC({ ...dataC, lastName: e.target.value })}
            />

            <input
              type="text"
              id="simple-search"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Celular"
              required
              value={dataC.cellphone}
              onChange={(e) =>
                setDataC({ ...dataC, cellphone: e.target.value })
              }
            />
          </div>
        </div>
        <div className="mt-5">
          <button
            disabled={fetching}
            aria-disabled={fetching}
            onClick={() => handleUpdateEmployee()}
            className="p-2.5 ms-2 text-sm font-medium text-white bg-richBlack rounded-lg"
          >
            Actualizar Datos
          </button>
        </div>
        {done && (
          <p className="text-green-700 text-sm mt-2">
            Se actualizó el empleado correctamente
          </p>
        )}
      </div>
    </div>
  );
}

export default EditEmployee;
